import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  /* eslint-disable-next-line */
  $('.helpTextToggle').click(function () {
    $(this).find('span.helpTextToggleIcon').text((_, value) => (value === '-' ? '+' : '-'))
    $(this).next('.hideForm').stop().slideToggle(100, () => {})
  })
})
